let header = document.querySelector("header");
let navbarDesk = header.querySelector(".nav-desktop");
let navbarMobile = header.querySelector(".nav-mobile");
let navDrop = header.querySelector(".nav-drop");
let hamburger = header.querySelector(".ham");
let navCloseBtn = header.querySelector(".nav-close");
/////////////// Drop down
let dropDown = navbarDesk.dataset.style;
if (header.classList.contains("sticky-header")) {
  header.closest(".shopify-section").classList.add("header-sticky-header");
  header.closest(".shopify-section").style.backgroundColor =
    header.style.backgroundColor;
}

if (dropDown == "nested") {
  navbarDesk.querySelectorAll("li").forEach(function (el, ind) {
    let drop = el.querySelector(".level-1.nested-item");
    el.addEventListener("mouseenter", function () {
      drop?.classList.add("visible");
    });
    el.addEventListener("mouseleave", function () {
      drop?.classList.remove("visible");
    });
  });
} else {
  navbarDesk
    .querySelector("ul")
    .querySelectorAll("li")
    .forEach(function (el, ind) {
      let drop = el.querySelector(".level-1");
      el.addEventListener("mouseenter", function () {
        drop?.classList.add("visible");
      });
      el.addEventListener("mouseleave", function () {
        drop?.classList.remove("visible");
      });
    });
}
/////////////////////Mobile nav
// navbarMobile.querySelectorAll("li").forEach(function (el, ind) {
//   el.addEventListener("click", function (e) {
//     e.stopPropagation();
//     let url = el.querySelector("a").getAttribute("href");
//     if(url == null){
//       e.preventDefault();
//     }
//     el.classList.add("visible");
//   });
// });
// navbarMobile.querySelectorAll(".prev-nav").forEach(function (el, ind) {
//   el.addEventListener("click", function (e) {
//     e.preventDefault();
//     e.stopPropagation();
//     let li = el.closest(".visible");
//     if (!li) return;
//     li.classList.remove("visible");
//   });
// });
const parents = navbarMobile.querySelectorAll(".parent");

parents.forEach(parent => {
  const parentLink = parent.querySelector(":scope > a");
  const childMenu = parent.querySelector(":scope > .child-menu");
  
  if (parentLink) {
    parentLink.addEventListener("click", (e) => {
      // If the link has an href and no children, allow navigation
      if (!childMenu && parentLink.hasAttribute('href')) {
        return;
      }
      
      e.preventDefault();
      e.stopPropagation();
      
      if (childMenu) {
        if (childMenu.classList.contains("unhide")) {
          childMenu.classList.remove("unhide");
          parent.classList.remove("menu-open");
          parentLink.style.borderBottom = "1px solid #bfbfbf";
        } else {
          childMenu.classList.add("unhide");
          parent.classList.add("menu-open");
          parentLink.style.borderBottom = "none";
        }
      }
    });
  }
});

// Handle child menu items (Clothes, Shoes, Accessories) - works for both tabs and vertical items
const childItems = navbarMobile.querySelectorAll(".child-menu > li");

childItems.forEach(childItem => {
  const childLink = childItem.querySelector(":scope > a");
  const grandchildMenu = childItem.querySelector(":scope > .grandchild-menu");
  
  if (childLink) {
    childLink.addEventListener("click", (e) => {
      // If the link has an href and no grandchildren, allow navigation
      if (!grandchildMenu && childLink.hasAttribute('href')) {
        return;
      }
      
      e.preventDefault();
      e.stopPropagation();
      
      if (grandchildMenu) {
        if (grandchildMenu.classList.contains("unhide")) {
          grandchildMenu.classList.remove("unhide");
          childItem.classList.remove("menu-open");
          childLink.style.borderBottom = "1px solid #bfbfbf";
        } else {
          grandchildMenu.classList.add("unhide");
          childItem.classList.add("menu-open");
          childLink.style.borderBottom = "none";
        }
      }
    });
  }
});

// Mobile Navbar Tab Switching
const mobileTabs = navbarMobile.querySelectorAll(".mobile-tab");
const tabPanels = navbarMobile.querySelectorAll(".tab-panel");

// Helper function to expand first child of a panel
const expandFirstChild = (panel) => {
  if (!panel) return;
  
  const firstChildItem = panel.querySelector(".child-menu > li:first-child");
  if (firstChildItem) {
    const grandchildMenu = firstChildItem.querySelector(".grandchild-menu");
    const childLink = firstChildItem.querySelector("a");
    
    if (grandchildMenu && !grandchildMenu.classList.contains("unhide")) {
      grandchildMenu.classList.add("unhide");
      firstChildItem.classList.add("menu-open");
      if (childLink) childLink.style.borderBottom = "none";
    }
  }
};

mobileTabs.forEach(tab => {
  tab.addEventListener("click", (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    const tabIndex = tab.getAttribute("data-tab-index");
    
    // Remove active class from all tabs and panels
    mobileTabs.forEach(t => t.classList.remove("active"));
    tabPanels.forEach(p => p.classList.remove("active"));
    
    // Add active class to clicked tab and corresponding panel
    tab.classList.add("active");
    const activePanel = navbarMobile.querySelector(`[data-tab-panel="${tabIndex}"]`);
    if (activePanel) {
      activePanel.classList.add("active");
      // Auto-expand first child when switching tabs
      expandFirstChild(activePanel);
    }
  });
});

// Auto-expand first child of the default active tab on load
const defaultActivePanel = navbarMobile.querySelector(".tab-panel.active");
if (defaultActivePanel) {
  expandFirstChild(defaultActivePanel);
}

const toggleNav = () => {
  navbarMobile.classList.toggle("show");
  navDrop.classList.toggle("show");
};
hamburger.addEventListener("click", toggleNav);
navCloseBtn.addEventListener("click", toggleNav);
navDrop.addEventListener("click", toggleNav);
